'use client';
import { convertDistance } from '@streetferret/geospatial/conversions';
import { cn, formatDistance } from '@streetferret/utils';
import { useMemo } from 'react';
import { type Unit, usePreferences } from '@streetferret/providers';

export interface DistanceProps {
  distance: number;
  completed?: number;
  originalUnit?: Unit;
  className?: string;
}
export function Distance({
  distance,
  completed,
  className,
  originalUnit = 'imperial',
}: DistanceProps) {
  const { unit } = usePreferences();
  const fromUnit = originalUnit === 'imperial' ? 'miles' : 'meters';
  const toUnit = unit === 'imperial' ? 'miles' : 'kilometers';
  const distanceConverted = convertDistance(distance, fromUnit, toUnit);
  const distanceFormatted = formatDistance(distanceConverted);
  const unitFormatted =
    unit === 'imperial' ? 'mi' : unit === 'metric' ? 'km' : 'mi';

  const completedFormatted = useMemo(() => {
    if (completed === undefined) return undefined;
    const completedConverted = convertDistance(completed, fromUnit, toUnit);
    return formatDistance(completedConverted);
  }, [completed, fromUnit, toUnit]);

  if (completedFormatted === undefined) {
    return (
      <div className={className}>
        {distanceFormatted}
        <span className="ml-1">{unitFormatted}</span>
      </div>
    );
  }
  return (
    <div className={cn('inline-flex gap-1', className)}>
      <span>{completedFormatted}</span>
      <span>/</span>
      <span>{distanceFormatted}</span>
      <span>{unitFormatted}</span>
    </div>
  );
}
